import { dateFormat } from 'utils/shared/utils';
import { addDays } from 'utils/utils';

export interface PredefinedCity {
  lat: number;
  lon: number;
  city: string;
  id: string;
  types: string;
}

export class SearchHotelModel {
  checkIn: string;
  checkOut: string;
  starRating: number;
  nationality: string;
  searchRadius: number;
  city: string;
  lat: number;
  lon: number;
  roomsString: string;
  id: string;
  types: string;
  selectedHotelName?: string;
  suppliers: string;
  freeCancellation: boolean;
  displayExactly: boolean;

  constructor(params?: URLSearchParams, predefined?: PredefinedCity, b2b?: boolean) {
    if (params) {
      const paramsObj = Object.fromEntries(params.entries());
      this.checkIn = paramsObj.checkIn;
      this.checkOut = paramsObj.checkOut;
      this.starRating = parseFloat(paramsObj.starRating);
      this.nationality = paramsObj.nationality;
      this.searchRadius = parseFloat(paramsObj.searchRadius);
      this.city = paramsObj.city;
      this.lat = parseFloat(paramsObj.lat);
      this.lon = parseFloat(paramsObj.lon);
      this.roomsString = paramsObj.roomsString;
      this.id = paramsObj.id;
      this.types = paramsObj.types;
      this.selectedHotelName = paramsObj.selectedHotelName;
      this.suppliers = paramsObj.suppliers;
      this.freeCancellation = paramsObj.freeCancellation === 'true';
      this.displayExactly = paramsObj.displayExactly === 'true';
    } else {
      if (b2b) {
        this.checkIn = dateFormat(new Date(), 'yyyy-MM-dd', 'en');
        this.checkOut = dateFormat(addDays(4), 'yyyy-MM-dd', 'en');
      } else {
        this.checkIn = dateFormat(addDays(30), 'yyyy-MM-dd', 'en');
        this.checkOut = dateFormat(addDays(33), 'yyyy-MM-dd', 'en');
      }
      this.starRating = 0;
      this.nationality = '';
      this.searchRadius = 1;
      this.city = predefined?.city || '';
      this.lat = predefined?.lat || 0;
      this.lon = predefined?.lon || 0;
      this.roomsString = '';
      this.id = predefined?.id || '';
      this.types = predefined?.types || '';
      this.selectedHotelName = '';
      this.suppliers = '';
      this.freeCancellation = false;
      this.displayExactly = false;
    }
  }
}
